export default Object.freeze({
	CRIADO: { value: 'CRIADO', text: 'Adicionado' },
	JUNTADO: { value: 'JUNTADO', text: 'Juntado' },
})
